import type { ApplianceRepository, UpdateAppliance } from "~application/devices/ports/appliance-repository.ts";
import type { ApplianceTypeId, ApplianceTypeModel } from "~domain/devices/models/appliances/appliance-type-model.ts";
import type { BackofficeSdkClient } from "~infrastructure/api/backoffice/http/backoffice-sdk-client.ts";

import { patchAppliance, getApiApplianceType } from "~infrastructure/.generated/hey/backoffice-backend";
import { handleBackofficeError } from "~infrastructure/api/backoffice/http/backoffice-error-handler.ts";

export class BackofficeApplianceRepository implements ApplianceRepository {
  constructor(private readonly backofficeApi: BackofficeSdkClient) {}

  async findAppliancesByType(): Promise<Array<ApplianceTypeModel>> {
    const response = await getApiApplianceType({
      client: this.backofficeApi.client,
    });

    if (response.error) {
      throw handleBackofficeError(response.error);
    }

    return (response.data.types ?? []).map((type) => ({
      id: type.id as ApplianceTypeId,
      description: type.description,
    }));
  }

  async updateAppliance(input: UpdateAppliance) {
    const response = await patchAppliance({
      client: this.backofficeApi.client,
      body: {
        applianceTypeId: input.applianceTypeId,
        localisation: input.applianceLocation,
      },
      path: { csApplianceId: input.applianceId },
    });

    if (response.error) {
      throw handleBackofficeError(response.error);
    }

    return;
  }
}
